"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHOOL_EMAIL_SUBSTRINGS = void 0;
exports.isSchoolEmail = isSchoolEmail;
/**
 * School-user detection by email domain (the part after the @).
 * Intentionally permissive (substring match — ISP domains like comcast.net hit
 * '.net' by design); used only to soft-default the /deals view, never as a
 * security gate. Local parts are excluded so e.g. eduardo@gmail.com won't match.
 */
exports.SCHOOL_EMAIL_SUBSTRINGS = [
    'edu',
    '.org',
    '.net',
    'k12',
    'prep',
    'college',
    'uni',
    'university',
    'isd',
    'school',
    'academy',
    'charter',
    'unified',
];
function isSchoolEmail(email) {
    var _a, _b;
    const domain = (_b = (_a = email.split('@')[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
    if (!domain)
        return false;
    return exports.SCHOOL_EMAIL_SUBSTRINGS.some((s) => domain.includes(s));
}
